<template>
  <Catalog
    title="Должность"
    name-label="Название"
    description-label="Например: Генеральный директор, Менеджер"
    submit-error="Укажите название должности."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="createId"
    v-on="$listeners"
  >
    <template #optional-skeleton>
      <b-row class="mb-2">
        <b-col>
          <b-skeleton width="32%" height="16%" class="mb-2"/>
          <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
          <b-skeleton width="29%" height="15%" class="mb-0"/>
        </b-col>
      </b-row>
    </template>

    <template v-slot:optional-fields="{ model }">
      <b-form-group
        id="group-short-name"
        label="Короткое название"
        label-for="input-short-name"
        description="Например: Ген. дир."
      >
        <b-form-input
          id="input-short-name"
          type="text"
          size="sm"
          v-model="model.short_name"
          trim
        ></b-form-input>
      </b-form-group>
    </template>
  </Catalog>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "JobTitle",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getJobTitleById(id);
    },
    async putData(data) {
      return await this.putJobTitle(data)
    },
    async postData(data) {
      return await this.postJobTitle(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/JobTitles/JobTitle.vue